import { render, staticRenderFns } from "./minAdvertisement.vue?vue&type=template&id=33edb440&scoped=true&"
import script from "./minAdvertisement.vue?vue&type=script&lang=ts&"
export * from "./minAdvertisement.vue?vue&type=script&lang=ts&"
import style0 from "./minAdvertisement.vue?vue&type=style&index=0&id=33edb440&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edb440",
  null
  
)

export default component.exports